import router from '@/router';
import { httpClient } from '@/utils/request/http';
import { removeUserInfo } from '@/services/auth/user';

export default {
  logout() {
    httpClient.post('/auth/logout').catch(() => {});
    removeUserInfo();
    localStorage.clear();
    router.push({ name: 'login' });
    window.location.reload();
  },
};
